import Image from "next/image";
import React from 'react'
import styles from "./tnpsc-group-iv-test-batch.module.css";
import Banner from "../../assets/images/Tnpsc/IM-TOP-GR---IV-TEST-SERIES---Web-Banner.jpg";
import MobBanner from "../../assets/images/Tnpsc/IM-TOP-GR---IV-TEST-SERIES---Mobile-Banner.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from 'next/link';
import Head from 'next/head';

const Tnpsc_gr_IV_testbatch = () => {

const feestructure3 = [
  {
    center: "Anna Nagar",
    fee: {
      new: "New Student : ₹5,500",
      old: "Old Student : ₹5,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline",
        start: "14-07-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IV-PrelimsTest-2026/Anna-nagar/Tnpsc-GRP-IV-Prelims-B1-2026.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC",
      },

      {
        batch: "Batch I -  Online",
        start: "14-07-2026",
        schedule:
           "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IV-PrelimsTest-2026/Anna-nagar/Tnpsc-GRP-IV-Prelims-B1-2026.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=ONLINE TEST BATCH&coursetype=TNPSC",
      },
    
    ],
  },

   {
    center: "Thiruvarur",
    fee: {
      new: "New Student : ₹5,500",
      old: "Old Student : ₹5,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline",
        start: "20-07-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IV-PrelimsTest-2026/Thiruvarur/Tnpsc-GRP-IV-Prelims-B1-2026.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC",
      },

    ],
  },


   {
    center: "Adyar",
    fee: {
      new: "New Student : ₹5,500",
      old: "Old Student : ₹5,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline",
        start: "21-07-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IV-PrelimsTest-2026/Adyar/Tnpsc-GRP-IV-Prelims-B1-2026.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC",
      },

    ],
  },


  {
    center: "Coimbatore",
    fee: {
      new: "New Student : ₹5,500",
      old: "Old Student : ₹5,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline",
        start: "21-07-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IV-PrelimsTest-2026/Coimbatore/Tnpsc-GRP-IV-Prelims-B1-2026.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC",
      },

    ],
  },


  {
    center: "Namakkal",
    fee: {
      new: "New Student : ₹5,500",
      old: "Old Student : ₹5,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline",
        start: "22-07-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IV-PrelimsTest-2026/Namakkal/Tnpsc-GRP-IV-Prelims-B1-2026.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC",
      },

    ],
  },


  {
    center: "Madurai",
    fee: {
      new: "New Student : ₹5,500",
      old: "Old Student : ₹5,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline",
        start: "22-07-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IV-PrelimsTest-2026/Madurai/Tnpsc-GRP-IV-Prelims-B1-2026.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC",
      },

    ],
  },


  {
    center: "Trichy",
    fee: {
      new: "New Student : ₹5,500",
      old: "Old Student : ₹5,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline",
        start: "24-07-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IV-PrelimsTest-2026/Trichy/Tnpsc-GRP-IV-Prelims-B1-2026.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=Trichy&coursetype=TNPSC",
      },

    ],
  },

   {
    center: "Salem",
    fee: {
      new: "New Student : ₹5,500",
      old: "Old Student : ₹5,000",
    },
    batches: [
      {
        batch: "Batch I -  Offline",
        start: "25-07-2026",
        schedule:
          "https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GRP-IV-PrelimsTest-2026/Salem/Tnpsc-GRP-IV-Prelims-B1-2026.pdf",
        admission:
          "https://admissionsv1.shankariasacademy.com/?center=Salem&coursetype=TNPSC",
      },

    ],
  },

  
]



    return (
        <>

        <Head>
            <meta charset="UTF-8" />  
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group 4 Test Batch | Shankar IAS Academy</title>
            <meta name="title" content="TNPSC Group 4 Test Batch | Shankar IAS Academy" />
            <meta name="description" content="Shankar IAS Academy's TNPSC Group 4 Test Batch: Elevate your preparation with expert coaching and proven strategies. Get success in Group 4 exams!" />
            <meta name="keywords" content="TNPSC Group 4 Test Batch, TNPSC Group 4 Test Series, TNPSC Group 4 Mock Test, TNPSC Group 4 Online Test, TNPSC Group 4 Coaching, Shankar IAS Academy TNPSC, TNPSC Group 4 Preparation, TNPSC Group 4 Practice Test,  TNPSC Group 4 Exam 2026"></meta>
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-iv-test-batch/ " />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group 4 Test Batch | Shankar IAS Academy" />
            <meta property="og:description" content="Shankar IAS Academy's TNPSC Group 4 Test Batch: Elevate your preparation with expert coaching and proven strategies. Get success in Group 4 exams!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-iv-test-batch/ " />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

            <Navbar title="tnpsc" />

            <div className="container">
                <div className="pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>I'M TOP TNPSC Group IV Test Series - 2026</h1>
                </div>
            </div>

       <div className="container pb-4">

            <div className="row d-none d-md-block">
                <div className="col pt-3 pt-md-2">
                    <Image src={Banner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group IV Prelims Test" className="img-fluid w-100"/>
                </div>
            </div>

            <div className="row d-block d-md-none">
                <div className="col pt-3 pt-md-5">
                    <Image src={MobBanner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group IV Prelims Test" className="img-fluid w-100"/>
                </div>
            </div> 
       </div>

 {/* table */}

        <section className={styles.courseSection}>
           <div className="container">
                <div className={styles.headingBox}>
                    <h2> I'M TOP TNPSC Group IV Test Batch</h2>
                    {/* <span> General Tamil & General English</span> */}
                </div>

                <div className={`${styles.tableWrapper} d-none d-md-block`}>
                    <table className={styles.courseTable}>
                        <thead>
                           <tr>
                              <th>Center</th>
                              <th>Batch</th>
                              <th>Starts On</th>
                              <th>Fee</th>
                              <th>Schedule</th>
                              <th>Admission</th>
                            </tr>
                        </thead>

                        <tbody >
                                {feestructure3.map((centerItem) =>
                                    centerItem.batches.map((batch, index) => (
                                        <tr key={index}>

                                        {/* Center Common */}
                                        {index === 0 && (
                                            <td rowSpan={centerItem.batches.length}>
                                            {centerItem.center}
                                            </td>
                                        )}

                                        {/* Batch */}
                                        <td>{batch.batch}</td>

                                        {/* Start */}
                                        <td>{batch.start}</td>

                                        {/* Fee Separate */}
                                        <td>
                                            <div>{centerItem.fee.new}</div>
                                            <div>{centerItem.fee.old}</div>
                                        </td>
                                    

                                        {/* Schedule */}
                                        <td>
                                            {batch.schedule !== "#" ? (
                                            <a href={batch.schedule} target="_blank">
                                                <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                                                View Pdf
                                            </a>
                                            ) : (
                                            <span>Update Soon</span>
                                            )}
                                        </td>

                                        {/* Admission */}
                                        <td>
                                            <a href={batch.admission} target="_blank">
                                            <button className={styles.payBtn}>
                                                Pay Now
                                            </button>
                                            </a>
                                        </td>

                                        </tr>
                                    ))
                                    )}
                        </tbody>
                    </table>
                </div>

                <div  className={`${styles.mobileView} d-block d-md-none`}>
                    {feestructure3.map((centerItem, centerIndex) =>
                      centerItem.batches.map((batch, index) => (
                        <div className={styles.card} key={index}>
                                        
                          <div className={styles.row}>
                             <span>Center</span>
                             <strong>{centerItem.center}</strong>
                          </div>

                          <div className={styles.row}>
                             {/* <span>Batch</span> */}
                             <strong>{batch.batch}</strong>
                          </div>

                          <div className={styles.row}>
                              <span>Start Date</span>
                              <strong>{batch.start}</strong>
                          </div>

                          <div className={styles.row}>
                            <span>Fee</span>
                            <strong>{centerItem.fee.new}</strong>
                          </div>

                          <div className={styles.row}>
                            <span>Old Fee</span>
                            <small>{centerItem.fee.old}</small>
                          </div>

                          <div className={styles.actions}>
                            <span>Schedule</span>
                              {batch.schedule !== "#" ? (
                                                <a href={batch.schedule} target="_blank">
                                                View
                                                </a>
                                            ) : (
                                                <span>Update Soon</span>
                                            )}
                          </div>

                          <div className={styles.actions}>
                                            <a href={batch.admission} target="_blank">
                                                <button className={styles.payBtn}>
                                                Pay Now
                                                </button>
                                            </a>
                          </div>

                        </div>
                      ))
                    )}
                </div>
            </div>
        </section>	

            <Footer />
        </>
    )
}

export default Tnpsc_gr_IV_testbatch;